export default "__VITE_ASSET__DT36oRQI__"